export default __webpack_public_path__ + "static/media/ll.fd735495.png";